import Vue from 'vue'
import AscGridDrillDownCell from '@/components/molecules/AscGridDrillDownCell'

export default Vue.extend({
  components: {
    AscGridDrillDownCell,
  },

  data: function () {
    return {}
  },

  computed: {
    getDataValue() {
      return this.params.value
    },
  },

  template: `<asc-grid-drill-down-cell 
  :value="getDataValue" />`,
})
